// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-2SzEb";
export { _1 as "__esModule", _2 as "content" }
export default { "__esModule": _1, "content": _2 }
